module.exports = __webpack_public_path__ + "static/media/archive.fbcbcf4c.svg";